import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { AuthRoute, IAuthRoute } from "../../components/AuthRoute";
import { PageNotFound } from "../../components/PageNotFound";
import { routeLoader } from "@advapacs/common";

const CustomerPACSListContainer = React.lazy(() =>
  routeLoader(() => import("./CustomerPACSListContainer"))
);

const routes: Array<IAuthRoute> = [
  {
    path: "/",
    element: <CustomerPACSListContainer />,
    can: [],
    index: true,
  },
];

const CustomerPACSRoute: FC = () => {
  return (
    <>
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              index={route.index}
              element={<AuthRoute can={route.can} element={route.element} />}
            />
          );
        })}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export const CustomerPACSRouter = {
  element: <CustomerPACSRoute />,
  path: "/PACSDirectory/*",
};
